import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  useCaseList: [],
};

export const relatedUseCasesSlice = createSlice({
  name: "relatedUseCases",
  initialState,
  reducers: {
    relatedUseCasesStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    relatedUseCasesSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      useCaseList: action.payload,
    }),
    relatedUseCasesFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    resetReletedUseCases: () => ({
      ...initialState,
    })
  },
});

export const { 
  relatedUseCasesStart,
  relatedUseCasesSuccess,
  relatedUseCasesFailure,
  resetReletedUseCases,
} = relatedUseCasesSlice.actions;

export const getRelatedUseCases = (id, fromCaseExamples) => (dispatch) => {
  dispatch(relatedUseCasesStart());
  let apiPath = fromCaseExamples ? 
    `${Constants.API.CASE_EXAMPLES}/${id}${Constants.API.RELATED}${Constants.API.USE_CASE_TERM}` :
    `${Constants.API.USE_CASE_DETAIL}/${id}${Constants.API.RELATED}`;

  apiService.get(apiPath).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(relatedUseCasesSuccess(data?.data));
      } else {
        dispatch(relatedUseCasesFailure());
      }
    } else {
      dispatch(relatedUseCasesFailure());
    }
  }).catch(() => {
    dispatch(relatedUseCasesFailure());
  })
};

export default relatedUseCasesSlice.reducer;
